import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Table } from 'primeng/table';
import { ProductService } from 'src/app/services/product.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver/src/FileSaver';
import { maxYearFunction } from '../../../_helpers/utility';
import * as moment from "moment";
import { CategoryService } from 'src/app/services/category.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserService } from '../../../services/user.service';


@Component({
    templateUrl: './academyReferrerList.component.html',
    styleUrls: ['./academyReferrerList.component.scss'],
    providers: [MessageService, ConfirmationService, TitleCasePipe]
})
export class AcademyReferrerListComponent implements OnInit {
    errorMessage = '';
    private lastTableLazyLoadEvent: LazyLoadEvent;
    loading: boolean;
    referrerlist: any;
    totalRecords: 0;
    public loggedInUser;
    userId: any;
    paginationOption;


    constructor(private el: ElementRef, private userService: UserService, private titlecasePipe: TitleCasePipe, private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService,
        private categoryService: CategoryService,
        private renderer: Renderer2,
        private tokenStorageService: TokenStorageService,) { }
    ngOnInit() {
        this.renderer.addClass(document.body, 'referee-list-page');
        this.paginationOption = environment.pagination;
        this.loggedInUser = this.tokenStorageService.getUser();
        if (this.loggedInUser.userdata != undefined) {
            this.userId = this.loggedInUser.userdata.id;
        }
        // this.loadAcademyReferrerList(this.lastTableLazyLoadEvent)
    }
    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'referee-list-page');
      }
    loadAcademyReferrerList(event: LazyLoadEvent) {

        this.lastTableLazyLoadEvent = event;
        var query = "&filterByDisable=false";

        this.userService.getAcademyReferrerList(this.userId, query).subscribe(
            data => {
                window.scroll(0, 0);
                this.loading = false;
                this.referrerlist = data.items;
                this.totalRecords = data.totalCount;
            },
            err => {
                this.errorMessage = err.error.message;
            });
    }

    referralIncomeDetails(referralId) {
        let initialReferralIncomeHistoryValues = { page: 1, limit: 10};
        window.localStorage.setItem('referral-income-history',JSON.stringify(initialReferralIncomeHistoryValues));
        this.router.navigate(["/academies-profile/academy-referrer-list/" + this.userId + "/" + referralId]);
    }

}
